import { render } from "./PrivacyAndAccess.vue?vue&type=template&id=783616f0"
import script from "./PrivacyAndAccess.vue?vue&type=script&lang=js"
export * from "./PrivacyAndAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__